module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/cotizacion/cotizacion-list/cotizacion-list.component.scss
// module id = ./src/app/shared-components/cotizacion/cotizacion-list/cotizacion-list.component.scss
// module chunks = main